import ApplicationController from "../../application_component_controller"

import { useOutlets } from "hb/insights/use_outlets"

export default class extends ApplicationController {
  connect() {
    useOutlets(this, {
      components: ["handsfree"],
      scope: this.element.closest(".handsfree-parent"),
    })
  }

  nestedOpen(evt) {
    if(evt.shiftKey) {
      evt.target.parentElement.querySelectorAll(`:scope .nested-data`).forEach(el => {
        el.classList.remove("closed")
      })
    }
    evt.target.parentElement.classList.remove("closed")
  }

  nestedClose(evt) {
    if(evt.shiftKey) {
      evt.target.parentElement.querySelectorAll(`:scope .nested-data`).forEach(el => {
        el.classList.add("closed")
      })
    }
    evt.target.parentElement.classList.add("closed")
  }

  valSel(evt) {
    if (!window.getSelection().isCollapsed) {
      return
    }

    const {type, value, path, prepend} = evt.target.dataset
    let opts = {
      element: this.element,
      addToField: true
    }

    if (prepend !== undefined) {
      try {
        opts.prepend = JSON.parse(prepend)
      } catch (e) {
        console.error("Could not parse prepend", e)
      }
    }
    this.outletComponent("handsfree").show(type, path, value, opts)
  }
}
